import IUserApplicationsFilter from "interfaces/IUserApplicationsFilter";

const initialUserApplicationsFilter = () : IUserApplicationsFilter => ({
  applicationTypes: [],
  groups: [],
  searchText: ""
});

export { initialUserApplicationsFilter };
